import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const SoftwareDevelopment = () => {
  return (
    <main>

      {/* 🔥 HERO SECTION WITH IMAGE */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(5,25,55,0.8), rgba(5,25,55,0.9)), url('https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "100px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>
            Software & Application Development
          </h1>
          <p style={{ maxWidth: "700px", margin: "auto" }}>
            We build scalable, secure, and high-performance software solutions
            tailored to your business needs.
          </p>
        </Container>
      </section>

      {/* INTRO */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Custom Software Solutions</h2>
              <p>
                From startups to enterprises, we develop digital products that
                are reliable, scalable, and future-ready. Our team focuses on
                clean architecture, performance, and user experience.
              </p>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg"
                alt="software"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* WHAT WE BUILD */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">What We Build</h2>

          <Row className="g-4">

            {[
              "Web Applications",
              "Enterprise Software",
              "Mobile Applications",
              "Custom Platforms",
              "API Integration",
              "AI Applications"
            ].map((item, index) => (
              <Col md={6} lg={4} key={index}>
                <Card className="gov-card p-4 h-100 text-center">
                  <h5>{item}</h5>
                  <p>
                    Scalable and performance-focused solutions designed for real-world usage.
                  </p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* TECH STACK WITH BACKGROUND */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('https://images.pexels.com/photos/11035380/pexels-photo-11035380.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <Row className="align-items-center">

            <Col lg={6}>
              <h2>Technologies We Use</h2>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "React, HTML, CSS",
                  "Python (Django), Node.js",
                  "MySQL, PostgreSQL",
                  "Azure, AWS",
                  "Docker, Kubernetes",
                  "AI & Machine Learning"
                ].map((item, i) => (
                  <li key={i} className="mb-2 d-flex align-items-center gap-2">
                    <CheckCircle size={18} color="lightgreen" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg"
                alt="tech"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* PROCESS */}
      <section className="gov-section">
        <Container>
          <h2 className="text-center mb-5">Our Development Process</h2>

          <Row className="g-4 text-center">
            {[
              "Requirement Analysis",
              "Design & Planning",
              "Development",
              "Testing",
              "Deployment",
              "Support"
            ].map((step, index) => (
              <Col md={4} key={index}>
                <Card className="gov-card p-4 h-100">
                  <h5>Step {index + 1}</h5>
                  <p>{step}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Ready to Build Your Software?</h2>
          <p>Let’s turn your idea into a powerful digital solution.</p>

          <Button href="/contact" size="lg" variant="light">
            Start Your Project
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default SoftwareDevelopment;